export default __webpack_public_path__ + "static/media/gears-cogwheels.5a413832.jpg";